// Transporter names typed in info CSV files often differ from the saved ones
// only by case or surrounding spaces ("Rousseau" vs "ROUSSEAU").

function cleanName(name) {
  if (name === undefined || name === null) {
    return '';
  }
  return name.toString().trim();
}

export function isSameTransporter(firstName, secondName) {
  return cleanName(firstName).localeCompare(
    cleanName(secondName),
    'fr',
    { sensitivity: 'accent' },
  ) === 0;
}

// Returns the saved transporter name matching `name`, or '' when none does.
// An exact match wins over a case-insensitive one.
export function findExistingTransporter(transporters, name) {
  const candidate = cleanName(name);
  if (candidate === '') {
    return '';
  }
  const savedNames = transporters.filter((transporter) => typeof transporter === 'string');
  if (savedNames.includes(candidate)) {
    return candidate;
  }
  return savedNames.find((transporter) => isSameTransporter(transporter, candidate)) ?? '';
}
